import useMediaQuery from "./useMediaQuery";

const useIsDesktop = () => {
  return useMediaQuery("(min-width: 992px)");
};

export default useIsDesktop;
